import React from 'react';

const EasyPaisaIcon = ({
  topStoke = 'black',
  bottomStroke = 'green',
}: {
  topStoke?: string;
  bottomStroke?: string;
}) => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1573 6.10648C15.4042 5.04142 13.9571 4.48006 11.9566 4.58474C8.72004 4.75315 6.82267 6.73915 6.38066 8.60074C7.32034 9.5505 11.6455 10.4472 14.7969 9.44885C16.4127 8.93452 17.0446 7.36271 16.1573 6.10648ZM1.52344 9.15299C2.29614 3.77457 6.02541 0.321449 11.8583 0.0180119C15.36 -0.164051 18.9387 0.996597 20.913 4.04766C22.6516 6.7346 22.9577 12.0857 15.4812 13.5058C7.70178 14.9851 2.76434 11.5274 1.52344 9.15299Z"
        fill={topStoke}
      />
      <path
        d="M18.7582 13.912C17.6548 16.3213 14.618 17.7535 11.339 17.6185C6.23945 17.4091 2.45615 14.7374 1.05317 11.1993C0.537493 16.1863 3.70033 20.5087 9.34335 21.6891C15.4513 22.9681 21.3202 20.1401 22.9999 16.2591L18.7582 13.912Z"
        fill={bottomStroke}
      />
    </svg>
  );
};

export default EasyPaisaIcon;
